import { Button } from '../../../../core/components/atoms/Button';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../../../../core/components/templates/Modal';

interface IModalOnCancel {
  onCancel: () => void;
  action: () => void;
  isOpen: boolean;
  onClose: () => void;
}

export default function ModalOnCancel({
  onCancel,
  action,
  isOpen,
  onClose,
}: IModalOnCancel) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position='center'
      className='w-2/5 p-0'
    >
      <div className='flex flex-col gap-xl'>
        <Typography>
          Se você cancelar o envio da redação, o conteúdo será perdido e não
          poderá ser recuperado. Tem certeza de que deseja cancelar o envio?
        </Typography>
        <div className='flex flex-row items-center justify-end gap-sm'>
          <Button variant='text' onClick={() => onCancel()}>
            Cancelar
          </Button>
          <Button
            variant='text'
            className='text-feedback-color-error-pure'
            onClick={() => action()}
          >
            Cancelar envio
          </Button>
        </div>
      </div>
    </Modal>
  );
}
